import axios from 'axios';
import http from 'http';
import https from 'https';
import { Util } from './Util';
import AuthUserService from './AuthUserService';

export default class ClientRequestService {
    constructor(module) {
        this.util = new Util(module);
        this.baseURL = this.util.getBaseUrl();
        this.module = this.util.getModule();
    }

    async Get(config) {
        if (!config || !config.url) return Promise.reject("Error");

        if (!config.data) config.data = {};
        if (config.headers) config.headers = { headers: { ...this.defaultConfig.headers, ...config.headers } };
        config.data.ticks = new Date().valueOf();

        this.util.showWait();
        return await axios.get(
            `${this.baseURL}${!config.withModule ? `${this.module}/` : ''}${config.url}`,
            { ...this.defaultConfig, ...config.overrides || {}, params: config.data, ...config.headers || {} }
        ).then(
            res => {
                this.util.hideWait();
                if (this.util.hasException(res)) return Promise.reject("Error");
                else return Promise.resolve(config.getRawResponse ? res.data : res.data.Result);
            }, config.handleException === false ?
            this.util.errorCallback.bind(this.util, config.handleException) :
            this.util.errorCallback.bind(this.util)
        );
    }

    async Post(config) {
        if (!config || !config.url) return Promise.reject("Error");

        if (!config.data) config.data = {};
        if (config.headers) config.headers = { headers: { ...this.defaultConfig.headers, ...config.headers } };

        this.util.showWait();
        return await axios.post(
            `${this.baseURL}${!config.withModule ? `${this.module}/` : ''}${config.url}`,
            config.data,
            { ...this.defaultConfig, ...config.overrides || {}, ...config.headers || {} }
        ).then(
            res => {
                this.util.hideWait();
                if (config.handleCallerException === true) {
                    return Promise.resolve(config.getRawResponse ? res.data : res.data.Result);
                }
                else {
                    if (this.util.hasException(res)) return Promise.reject("Error");
                    else return Promise.resolve(config.getRawResponse ? res.data : res.data.Result);
                }
            }, config.handleException === false ?
            this.util.errorCallback.bind(this.util, config.handleException) :
            this.util.errorCallback.bind(this.util)
        );
    }

    async PostWithAbsoluteUrl(config) {
        if (!config || !config.url) return Promise.reject("Error");

        if (!config.data) config.data = {};

        this.util.showWait();
        return await axios.post(
            config.url,
            config.data,
            {
                'content-type': 'application/json'
            }
        ).then(
            res => {
                this.util.hideWait();
                if (config.handleCallerException === true) {
                    return Promise.resolve(config.getRawResponse ? res.data : res.data.Result);
                }
                else {
                    if (this.util.hasException(res)) return Promise.reject("Error");
                    else return Promise.resolve(config.getRawResponse ? res.data : res.data.Result);
                }
            }, config.handleException === false ?
            this.util.errorCallback.bind(this.util, config.handleException) :
            this.util.errorCallback.bind(this.util)
        );
    }

    async Put(config) {
        if (!config || !config.url) return Promise.reject("Error");

        if (!config.data) config.data = {};
        if (config.headers) config.headers = { headers: { ...this.defaultConfig.headers, ...config.headers } };

        this.util.showWait();
        return await axios.put(
            `${this.baseURL}${!config.withModule ? `${this.module}/` : ''}${config.url}`,
            config.data,
            { ...this.defaultConfig, ...config.overrides || {}, ...config.headers || {} }
        ).then(
            res => {
                this.util.hideWait();
                if (this.util.hasException(res)) return Promise.reject("Error");
                else return Promise.resolve(config.getRawResponse ? res.data : res.data.Result);
            }, config.handleException === false ?
            this.util.errorCallback.bind(this.util, config.handleException) :
            this.util.errorCallback.bind(this.util)
        );
    }

    async Delete(config) {
        if (!config || !config.url) return Promise.reject("Error");

        if (!config.data) config.data = {};
        if (config.headers) config.headers = { headers: { ...this.defaultConfig.headers, ...config.headers } };

        this.util.showWait();
        return await axios.delete(
            `${this.baseURL}${!config.withModule ? `${this.module}/` : ''}${config.url}`,
            { ...this.defaultConfig, ...config.overrides || {}, data: config.data, ...config.headers || {} }
        ).then(
            res => {
                this.util.hideWait();
                if (this.util.hasException(res)) return Promise.reject("Error");
                else return Promise.resolve(res);
            }, config.handleException === false ?
            this.util.errorCallback.bind(this.util, config.handleException) :
            this.util.errorCallback.bind(this.util)
        );
    }

    defaultConfig = {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Authorization': `Bearer ${new AuthUserService().getToken()}`
        },
        params: {},
        //paramsSerializer: function (params) { },
        timeout: 0,                                                                 // default is 0 (no timeout)
        withCredentials: false,                                                     // default
        responseType: 'json',                                                       // default
        responseEncoding: 'utf8',                                                   // default
        xsrfCookieName: 'XSRF-TOKEN',                                               // default
        xsrfHeaderName: 'X-XSRF-TOKEN',                                             // default
        onUploadProgress: function (progressEvent) { },
        onDownloadProgress: function (progressEvent) { },
        maxContentLength: 2000000,
        validateStatus: function (status) {
            return status >= 200 && status < 300;                                   // default
        },
        maxRedirects: 5,                                                            // default
        socketPath: null,                                                           // default
        httpAgent: new http.Agent({ keepAlive: true }),
        httpsAgent: new https.Agent({ keepAlive: true })
    };
}
